import React from "react";
import PropTypes from "prop-types";
import "./user-profile.m.css";
import { SvgHandler } from "../svg-handler/svg-handler";
import defaultAuthorIcon from "../../../assets/icons/user-icon.svg";
import { UserData } from "./user-profile-data";
import { breakpoint } from "../../../utils/breakpoint";

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserData: false
    };
  }

  toggleForm = event => {
    event.stopPropagation();
    event.preventDefault();
    this.props.openLoginTemplate();
  };

  render() {
    const { member, customCssClasses = "", logout } = this.props;
    return (
      <>
        {!member ? (
          <div onClick={event => this.toggleForm(event)} styleName={`sign-btn ${customCssClasses}`}>
            <span styleName="white-space" data-test-id="user-profile">
              {breakpoint("tablet") ? (
                <SvgHandler
                  xlinkHref={defaultAuthorIcon}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  svgWrapperClazzName="svg-wrapper"
                />
              ) : (
                <div styleName="sign-in-btn">SIGN IN</div>
              )}
            </span>
          </div>
        ) : (
          <UserData logout={logout} customCssClasses={customCssClasses} />
        )}
      </>
    );
  }
}
UserProfile.propTypes = {
  member: PropTypes.object,
  openLoginTemplate: PropTypes.func,
  logout: PropTypes.func,
  customCssClasses: PropTypes.string
};

export { UserProfile };
